
import request from '@/util/request';

// 详情
export const getContractDetail = (params, options) =>
    request.get('/api/v4ward/contract/detail', Object.assign({}, options, { params }));

// 阶段列表
export const getPaymentStageList = (params, options) =>
    request.get('/api/v4ward/contract/paymentstage/list', Object.assign({}, options, { params }));
// 阶段新增
export const savePaymentStage = (params, options) =>
    request.post('/api/v4ward/contract/paymentstage/save', params, options);
// 阶段删除
export const removePaymentStage = (params, options) =>
    request.post('/api/v4ward/contract/paymentstage/remove', params, options);
// 阶段编辑
export const updatePaymentStage = (params, options) =>
    request.post('/api/v4ward/contract/paymentstage/update', params, options);

// 合同金额统计
export const contractStatistics = (params, options) =>
    request.get('/api/v4ward/contract/statistics', Object.assign({}, options, { params }));
// 合同发票统计
export const invoiceStatistics = (params, options) =>
    request.get('/api/v4ward/contract/invoice/statistics', Object.assign({}, options, { params }));
// 合同跟进统计
export const followtaskStatistics = (params, options) =>
    request.get('/api/v4ward/contract/followtask/statistics', Object.assign({}, options, { params }));
// 合同日志
// export const getOperationRecordList = (params, options) =>
//     request.get('/api/v4ward/contract/operationrecord/list', Object.assign({}, options, { params }));
export const getOperationRecordList = (params, options) =>
    request.get('/api/v4ward/contract/operationrecord/change', Object.assign({}, options, { params }));
// 发票列表
export const getInvoiceList = (params, options) =>
    request.get('/api/v4ward/contract/invoice/list', Object.assign({}, options, { params }));
// 发票新增
export const saveInvoice = (params, options) =>
    request.post('/api/v4ward/contract/invoice/save', params, options);

// 付款列表
export const getPaymentRecordList = (params, options) =>
    request.get('/api/v4ward/contract/paymentrecord/list', Object.assign({}, options, { params }));
// 付款新增
export const savePaymentRecord = (params, options) =>
    request.post('/api/v4ward/contract/paymentrecord/save', params, options);
//付款记录修改
export const paymentrecordUpdate = (params, options) =>
    request.post('/api/v4ward/contract/paymentrecord/update', params, options);
//付款记录删除
export const paymentrecordRemove = (id) =>
    request.post('/api/v4ward/contract/paymentrecord/remove?ids='+id);
//付款记录回显
export const paymentrecordDetail = (params, options) =>
request.get('/api/v4ward/contract/paymentrecord/detail',Object.assign({}, options, { params }));
//付款记录回显图片 
export const paymentrecordImg = (params, options) =>
request.get('/api/v4ward/attach/getAttachByMainIdList',Object.assign({}, options, { params }));
// 跟进列表
export const getFollowTaskList = (params, options) =>
    request.get('/api/v4ward/contract/followtask/list', Object.assign({}, options, { params }));
// 跟进详情:
export const getFollowTaskDetail = (params, options) =>
    request.get('/api/v4ward/contract/followtask/detail', Object.assign({}, options, { params }));
// 跟进:任务新增
export const saveFollowTask = (params, options) =>
    request.post('/api/v4ward/contract/followtask/save', params, options);
// 跟进完成
export const finishFollowTask = (params, options) =>
    request.post('/api/v4ward/contract/followtask/finish', params, options);
// 跟进反馈新增
export const saveFollowFeedback = (params, options) =>
    request.post('/api/v4ward/contract/followfeedback/save', params, options);
// 跟进任务:跟进任务责任人
// projecId
    export const projectUserList = (params, options) =>
    request.get('/api/v4ward/user/project-user-list', Object.assign({}, options, { params }));






